export default __webpack_public_path__ + "static/media/Wrong-Answer.a800d8f6.mp3";